module.exports = __webpack_public_path__ + "img/btn_tooltip_close.399854ae.svg";